var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-err"},[_c('img',{staticClass:"error-page-image",attrs:{"src":_vm.IMG403,"alt":"403-image"},on:{"click":_vm.goBack}}),_c('el-button',{staticClass:"btn",attrs:{"size":"medium","type":"danger"},on:{"click":_vm.goBack}},[_vm._v("返回")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }